import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup } from "@angular/forms";

import { Funcionalidade } from "../../models/Funcionalidade.model";
import { Validation } from "./validation";
import { NgxSpinnerService } from "ngx-spinner";
import storageX from "src/app/storageCore/storageX";
import { STORAGE_KEY_CURRENT_USER } from "src/app/storageCore/constStorageKeys";
import { ApiBaseService } from "src/app/services/migrate/api.base.service";
import { Modulo } from "src/app/models/Modulo.model";
import { FuncionalidadeTipo } from "src/app/models/FuncionalidadeTipo.model";
import { extractFunctionalityErrorMessage, FUNCTIONALITY_ERROR_MESSAGES } from "src/app/utils/error-handler.util";

@Component({
  selector: "app-create-funcionalidade",
  templateUrl: "./form.component.html",
  styleUrls: ["./form.component.scss"],
})
export class CloneFuncionalidadeComponent implements OnInit {
  public funcionalidadeForm: FormGroup;
  public moduloSelected;
  public funcionalidadeTipoSelected;
  public funcionalidade: Funcionalidade;
  public funcionalidadeId: number;
  public title = "Duplicar Funcionalidade";
  public errorMessage;
  private validation: Validation;
  public types: any = [];
  public modulo: any = [];
  private apiBaseService: ApiBaseService;

  ngOnInit(): void {
    this.funcionalidadeForm = this.formBuilder.group(this.validation.rules());
    this.funcionalidadeId = this.activatedRoute.snapshot.params["id"];
    this.loadFuncionalidade(this.funcionalidadeId);
    this.setup();
  }
  async setup(): Promise<void> {
    const params = {
      size: 100,
      page: 0,
    };
    try {
      this.spinner.show();

      const modulo = await this.apiBaseService.get<any>({
        url: new Modulo()["nomeConsultaApiBase"],
        params,
      });
      this.modulo = modulo["content"];

      const types = await this.apiBaseService.get<any>({
        url: new FuncionalidadeTipo()["nomeConsultaApiBase"],
        params,
      });
      this.types = types["content"];
      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      throw new EvalError(error);
    }
  }

  public async loadFuncionalidade(id): Promise<void> {
    this.spinner.show();

    try {
      const response = await this.apiBaseService.get<Funcionalidade>({
        url: new Funcionalidade()["nomeConsultaApiBase"] + "/" + id,
      });

      this.funcionalidade = response as Funcionalidade;
      this.fillUserData();
      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      throw new EvalError(error);
    }
  }
  constructor(
    apiBaseService: ApiBaseService,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.apiBaseService = apiBaseService;
    this.validation = new Validation();
  }
  fillUserData(): void {
    this.moduloSelected = this.funcionalidade.modulo.id;
    this.funcionalidadeTipoSelected = this.funcionalidade.funcionalidadeTipo.id;

    if (this.moduloSelected) {
      this.funcionalidadeForm.controls["modulo"].setValue(this.moduloSelected);
    }
    if (this.funcionalidadeTipoSelected) {
      this.funcionalidadeForm.controls["funcionalidadeTipo"].setValue(
        this.funcionalidadeTipoSelected
      );
    }

    const fields = [
      "nmFuncionalidade",
      "dsFuncionalidade",
      "cdPath",
      "cdFuncionalidade",
      "sgFuncionalidade",
    ];
    fields.forEach((element) => {
      this.funcionalidadeForm.controls[element].setValue(
        this.funcionalidade[element]
      );
    });
  }

  public async submitForm(): Promise<void> {
    this.spinner.show();
    this.errorMessage = null; // Limpa mensagens de erro anteriores
    
    try {
      this.coverterUpperCase(this.funcionalidadeForm);
      const values = this.funcionalidadeForm.value;
      const post = {
        ...values,
        funcionalidadeTipo: { id: parseInt(values.funcionalidadeTipo) },
        modulo: { id: parseInt(values.modulo) },
        idUsuario: storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id,
      };

      await this.apiBaseService.post<Funcionalidade>(
        new Funcionalidade()["nomeConsultaApiBase"],
        post
      );
      this.spinner.hide();
      this.router.navigate(["/funcionalidade"]);
    } catch (error) {
      this.spinner.hide();
      
      // Extrai mensagem de erro específica usando utilitário
      this.errorMessage = extractFunctionalityErrorMessage(error, FUNCTIONALITY_ERROR_MESSAGES.CLONE_GENERIC);
      
      console.error('Erro ao clonar funcionalidade:', error);
    }
  }

  public coverterUpperCase(funcionalidadeForm: FormGroup) {
    funcionalidadeForm
      .get("nmFuncionalidade")
      .setValue(funcionalidadeForm.get("nmFuncionalidade").value.toUpperCase());
    funcionalidadeForm
      .get("dsFuncionalidade")
      .setValue(funcionalidadeForm.get("dsFuncionalidade").value.toUpperCase());
    funcionalidadeForm
      .get("cdFuncionalidade")
      .setValue(funcionalidadeForm.get("cdFuncionalidade").value.toUpperCase());
    funcionalidadeForm
      .get("sgFuncionalidade")
      .setValue(funcionalidadeForm.get("sgFuncionalidade").value.toUpperCase());
  }
}
